import styled from '@emotion/styled';

export const Wrapper = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  /* 
  @media screen and (min-width: 1440px) {
    position: absolute;
    // apps/jobmeeting/client/src/pages/Interviewer/Room/Header/style.ts의 padding값
    top: -14px;
    left: 50%;
    transform: translate(-50%, 0%);
    z-index: 999;
    margin: 0 auto;
  } */
`;

export const Content = styled.div`
  position: absolute;
  width: 376px;
  padding: 50px 35px;
  background: rgba(0, 0, 0, 0.6);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  text-align: center;
`;

export const ContentWrapper = styled.div`
  white-space: pre-wrap;
  color: #ffffff;
  font-size: 14px;
  line-height: 20px;
`;

export const ActionWrapper = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  text-align: center;
  vertical-align: middle;
  margin-top: 20px;
`;

export const Action = styled.button`
  display: flex;
  background-color: #ffffff;
  color: #000000;
  font-size: 13px;
  height: 36px;
  width: 104px;
  justify-content: center;
  align-items: center;
  border: 0;
  cursor: pointer;
`;
